import React, { useEffect, useState } from "react";
import { Box, SvgIcon, Collapse, Divider } from "@mui/material";
import { LuSlidersVertical } from "@/Components/Icons/Icons";
import DateSelector from "@/Components/Form/DateSelector";
import DateTimePicker from "@/Components/Form/DateTimePicker";
import InputTextField from "@/Components/Form/InputTextField";
import InputDropdown from "@/Components/Form/InputDropdown";
import { OutLinedButton } from "@/Components/Buttons/OutLinedButton";
import { BlackButton } from "@/Components/Buttons/FiledButton";
import { useDispatch } from "react-redux";
import { useSbType } from "@/Context/sbTypeContext";
import {
  customsHouse,
  sbTypeOptions,
  transportMode,
} from "@/Constant/Common/Common.jsx";
import {
  fillingmodeOptions,
  jobOwnerList,
  FllingModeList,
} from "@/Constant/Export/CreateNewJob/FilterBox.jsx";
import dayjs from "dayjs";
import { useUser } from "@/Context/UserContext";
import { mapExporterRequest } from "@/redux/mappers/Export/CreateNewJob/generalMapper";
import { hookMap } from "@/redux/hookMap";
import SuccessDialog from "@/Components/Dialog/SuccessDialog";
import { BiSolidError } from "react-icons/bi";
import { defaultValues } from "@/Constant/Common/Common";

export default function FilterBar({
  data = {},
  compKey = "general",
  exporterMasterId,
}) {
  const [showAdvanced, setShowAdvanced] = useState(false);
  const { sbType, setSbType } = useSbType();
  const { transportmode, setTransportMode } = useSbType();
  const { customsMode, setCustomsMode } = useSbType();
  const useApiHooks = hookMap["exporter"];
  const { create, update, fetch } = useApiHooks ? useApiHooks() : {};
  const [loading, setLoading] = useState(false);

  const [successDialogConfig, setSuccessDialogConfig] = useState(null);
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const [formDataJson, setFormDataJson] = useState({});
  const [isExporterAvailable, setIsExporterAvailable] = useState(false);
  const formData = useUser((state) => state.formData);
  const setFormData = useUser((state) => state.setFormData);
  const setExporterMasterId = useUser((state) => state.setExporterMasterId);
  const gateWayHooks = hookMap["getGateWayPort"];
  const { data: gateWayData, isLoading: gateWayLoading } = gateWayHooks();
  const {setTrigger} = useUser()
  useEffect(() => {
    setCustomsMode(null);
  }, []);

  const options = gateWayData?.map((data) => ({
    value: data.id,
    label: data.name,
  }));

  const handleChange = (field, value) => {
    console.log("value", value);
    let formattedValue = value;

    // if it's a dayjs object, save ISO string
    if (value && value.$d) {
      const finalValue =
        dayjs(value)
          .hour(0)
          .minute(0)
          .second(0)
          .millisecond(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      formattedValue = finalValue;
    }

    // store only the changed value in local formDataJson state to send to API

    setFormData((prev) => ({
      ...prev,
      [compKey]: {
        ...prev[compKey],
        [field]: formattedValue,
      },
    }));
    setFormDataJson((prev) => ({
      ...prev,
      [field]: formattedValue,
    }));
    console.log(formattedValue, "formattedValue ");
  };

  useEffect(() => {
    // run only when both local and incoming data are empty
    const isDataEmpty = !data || Object.keys(data).length === 0;
    const hasFormData =
      formData?.[compKey] && Object.keys(formData[compKey]).length > 0;

    if (isDataEmpty && !hasFormData) {
      setFormData((prev) => ({
        ...prev,
        [compKey]: {
          ...defaultValues,
        },
      }));

      setTransportMode(defaultValues.exportTransportMode);
      setCustomsMode(defaultValues.exportCustomHouse);
      setSbType(defaultValues.exportSBType);
    }
  }, [data, compKey]);

  const removeEmpty = (obj) => {
    if (Array.isArray(obj)) {
      return obj
        .map((item) => removeEmpty(item))
        .filter((item) => !(item === undefined));
    } else if (obj && typeof obj === "object") {
      // ✅ If the object has a "value" key, return just that
      if ("value" in obj) {
        return removeEmpty(obj.value);
      }

      const cleaned = Object.fromEntries(
        Object.entries(obj)
          .map(([k, v]) => [k, removeEmpty(v)])
          .filter(([_, v]) => v !== undefined) // remove empty fields
      );

      // ✅ If object became empty → keep it as {}
      return Object.keys(cleaned).length > 0 ? cleaned : {};
    }

    // ✅ Remove only invalid primitives
    if (obj === "" || obj === null || obj === "-") {
      return undefined; // field dropped
    }

    return obj;
  };
  const flattenData = (obj) => {
    if (!obj || typeof obj !== "object") return obj;

    // For objects with 'value' key, return only the value
    if ("value" in obj) return obj.value;

    if ("id" in obj) return obj.id;

    // Otherwise, recurse for nested objects
    return Object.fromEntries(
      Object.entries(obj).map(([k, v]) => [k, flattenData(v)])
    );
  };


  useEffect(() => {
    const isExporterAvailable = !!formData?.general?.exporterId;
    setIsExporterAvailable(isExporterAvailable);
  }, [formData]);

  const handleApply = async () => {
    setLoading(true);
    const updatedFormDataJson = {
      ...formDataJson,
      processingId: formData?.general?.processingId || null,
    };
    var data = mapExporterRequest(updatedFormDataJson);
    data = removeEmpty(flattenData(data));
    if (data.exportJob?.exporter) {
      data.exportJob.exporter = {};
    }
    let payload = {
      id: exporterMasterId,
      ...data,
    };

    try {
      let response;
      if (exporterMasterId && update) {
        // ✅ Update flow
        response = await update(payload).unwrap();
      } else if (create) {
        // ✅ Create flow
        response = await create(payload).unwrap();
      } else {
        console.warn("No valid API method found for");
      }

      if (response?.data?.statusCode === 200 || response?.statusCode === 200) {
        setSuccessDialogConfig({
          label: "Success",
          title: "",
          subtitle: (
            <strong style={{ fontSize: "1rem", color: "var(--brand-900)" }}>
              {response?.data?.message ||
                response?.message ||
                "Data save successfully"}
            </strong>
          ),
          buttonText: "OK",
          IconComponent: BiSolidError,
        });
        setShowSuccessDialog(true);
        // store exporterMasterId after create (if API returns it)
        if (response?.data) {
          // localStorage.setItem("exporterMasterId", response.data);
          // setFormData((prev) => ({ ...prev, id: response.data }));
          let fetchPayload = { id: response.data };
          const fetchResponse = await fetch(fetchPayload);
          setFormData((prev) => ({
            ...prev,
            [compKey]: {
              ...(prev[compKey] || {}),
              ...fetchResponse,
            },
          }));
          setExporterMasterId(response.data);
        }
        setTrigger((prev)=>prev+1)
      } else {
        setSuccessDialogConfig({
          label: "Failure",
          title: "",
          subtitle: (
            <strong style={{ fontSize: "1rem", color: "var(--brand-900)" }}>
              {response?.data?.message || "Something went wrong"}
            </strong>
          ),
          buttonText: "OK",
          status: "error",
          icon: BiSolidError,
        });
        setShowSuccessDialog(true);
      }
    } catch (error) {
      console.error("API call failed:", error);
      setSuccessDialogConfig({
        label: "Failure",
        title: "",
        subtitle: (
          <strong style={{ fontSize: "1rem", color: "var(--brand-900)" }}>
            {error?.data?.message || "Something went wrong"}
          </strong>
        ),
        buttonText: "OK",
        status: "error",
        icon: BiSolidError,
      });
      setShowSuccessDialog(true);
    } finally {
      setLoading(false);
      setShowAdvanced(false);
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: "var(--gray-0)",
        border: "1px solid var(--brand-200)",
        borderRadius: 2,
        py: 1,
      }}
    >
      {/* Primary Filter Row */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "var(--v-gap-sm-md)",
          mb: showAdvanced ? 1 : "var(--v-gap-xs)",
          px: 2,
        }}
      >
        {/* Job Number */}
        <InputTextField
          label="Job Number"
          disabled
          placeholder="New Entry"
          value={data.exporterJobNumber || ""}
          width="20%"
          onChange={(e) => handleChange("exporterJobNumber", e.target.value)}
        />

        {/* Job Date */}
        <DateSelector
          inputSize="medium"
          label="Job Date"
          width="20%"
          value={data.exportJobDate || null}
          onChange={(val) => handleChange("exportJobDate", val)}
          maxDateToToday={true} 
        />

        {/* Job Received On */}
        <DateTimePicker
          inputSize="medium"
          label="Job Received On"
          width="23%"
          value={
            data.exportJobReceivedOn
              ? dayjs(data.exportJobReceivedOn, "DD:MM:YYYY HH:mm")
              : null
          }
          
          onChange={(val) => handleChange("exportJobReceivedOn", val)}
          maxDateToToday={true} 

        />

        {/* Job Owner */}
        <InputDropdown
          placeholder="Select Owner"
          inputSize="medium"
          label="Job Owner"
          options={jobOwnerList}
          width="15%"
          value={data.exportJOBOwner || ""}
          onChange={(val) => handleChange("exportJOBOwner", val)}
        />

        {!showAdvanced ? (
          <Box sx={{ flexBasis: "15%" }}>
            <OutLinedButton
              variant="bodySmallMedium"
              label="Expand"
              startIcon={
                <SvgIcon sx={{ color: "var(--brand-600)" }}>
                  <LuSlidersVertical fontSize={"25px"} />
                </SvgIcon>
              }
              sx={{
                border: "1px solid var(--brand-600)",
                color: "var(--brand-600)",
                width: 200,
                mt: 3.6,
                backgroundColor: "var(--gray-0)",
                borderRadius: 2,
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "var(--gray-0)",
                },
              }}
              onClick={() => setShowAdvanced((prev) => !prev)}
            />
          </Box>
        ) : (
          <Box sx={{ flexBasis: "15%" }} />
        )}
      </Box>

      {/* Advanced Filters Section */}
      <Collapse in={showAdvanced}>
        <Box sx={{ display: "flex", gap: 1, flexDirection: "column" }}>
          {/* Row1 */}
          <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", px: 2 }}>
            <InputDropdown
              label="Filling mode"
              options={fillingmodeOptions}
              placeholder="Filling mode"
              width="15%"
              value={data.exporterJobFillingMode ?? ""}
              onChange={(val) => handleChange("exporterJobFillingMode", val)}
            />

            <InputDropdown
              label="Filling Type"
              placeholder="Filling Type"
              width="25%"
              options={FllingModeList}
              value={data.exporterJobFillingType || ""}
              onChange={(val) => handleChange("exporterJobFillingType", val)}
              disabled={
                data.exporterJobFillingMode?.toLowerCase() !== "icegate"
              } // ✅ disable unless icegate
            />

            <InputDropdown
              label="Transport Mode"
              placeholder="Transport Mode"
              width="13%"
              value={data.exportTransportMode || ""}
              disabled={data.exportTransportMode && data.exporterJobNumber} // disable if API data exists
              onChange={(val) => {
                setTransportMode(val);
                handleChange("exportTransportMode", val);
                console.log(
                  customsMode,
                  "customsMode",
                  customsHouse[val].some((opt) => opt.value === customsMode)
                );
                if (
                  !customsHouse[val]?.some((opt) => opt.value === customsMode)
                ) {
                  if (val === "air") {
                    handleChange("exportCustomHouse", "Bengaluru Air Cargo");
                    handleChange("exportLoadingPort", "Bengaluru Air Cargo");
                    setCustomsMode("Bengaluru Air Cargo");
                  } else {
                    handleChange("exportCustomHouse", "Chennai Sea");
                    handleChange("exportLoadingPort", "Chennai Sea");
                    setCustomsMode("Chennai Sea");
                  }
                }
              }}
              options={transportMode}
            />

            <InputDropdown
              label="Customs House"
              placeholder="Customs House"
              options={
                customsHouse[data.exportTransportMode] || customsHouse.air
              }
              value={data.exportCustomHouse || ""}
              onChange={(val) => {
                handleChange("exportCustomHouse", val);
                setCustomsMode(val);
              }}
              width="25%"
            />
          </Box>

          {/* Row2 */}
          <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", px: 2 }}>
            <InputDropdown
              label="Loading Port"
              placeholder="Loading Port"
              width="40%"
              value={data.exportLoadingPortId || ""}
              onChange={(e) => handleChange("exportLoadingPortId", e)}
              options={options || []}
            />

            <InputDropdown
              label="S/B Type"
              placeholder="S/B Type"
              value={data.exportSBType || ""}
              onChange={(val) => {
                handleChange("exportSBType", val);
                setSbType(val);
              }}
              options={sbTypeOptions}
              width="25%"
            />
          </Box>

          <Divider sx={{ my: 1 }} />

          {/* footer */}
          <Box
            sx={{
              display: "flex",
              gap: 2,
              flexWrap: "wrap",
              px: 2,
              justifyContent: "end",
            }}
          >
            <OutLinedButton
              variant={"bodySmallStrong"}
              label={"Close"}
              width="10%"
              height={40}
              onClick={() => setShowAdvanced(false)}
            />
            <BlackButton
              disabled={loading || !isExporterAvailable}
              label={loading ? "Saving..." : "Save"}
              width="10%"
              onClick={handleApply}
            />
          </Box>
        </Box>
      </Collapse>
      <SuccessDialog
        open={showSuccessDialog}
        onClose={() => {
          setShowSuccessDialog(false);
        }}
        {...successDialogConfig}
      />
    </Box>
  );
}
